import LocationsMapController from './locations-map';

export default angular
    .module('paysera.locationsMap.controllers', [])
    .controller('LocationsMapController', LocationsMapController)
    .name
;
